import {GatilhoCondicional} from './GatilhoCondicional';

export class CampoFormularioModel {
    static VISIBILIDADE_VISIVEL = 'visivel';
    static VISIBILIDADE_CONDICIONAL = 'condicional';

    id?: number;
    estrutura?: CampoFormularioEstruturaModel[];
    formulario_id?: number;
    campo_formulario_id?: any | CampoFormularioModel;
    titulo?: string;
    visibilidade?: string;
    gatilhos?: GatilhoCondicional[];
    idGrupo_aux?: number;
    gatilhos_condicionais?: GatilhoCondicional[];

    // CAMPO DE CONTROLE (NAO USADO NO BACK)
    _campoFormularioNome?: string;

    constructor(id?: number, estrutura?: CampoFormularioEstruturaModel[],
                formularioId?: number, titulo?: string, campoFormularioId?: number, visibilidade?: string,
                _campoFormularioNome?: string | undefined, gatilhos?: GatilhoCondicional[], idGrupo_aux?: number) {
        this.id = id;
        this.estrutura = estrutura ? estrutura : [];
        this.formulario_id = formularioId;
        this.titulo = titulo;
        this.campo_formulario_id = campoFormularioId;
        this.visibilidade = visibilidade ? visibilidade : CampoFormularioModel.VISIBILIDADE_VISIVEL;
        this._campoFormularioNome = _campoFormularioNome;
        this.gatilhos = gatilhos ? gatilhos : [];
        this.idGrupo_aux = idGrupo_aux;
    }
}

export class CampoFormularioEstruturaModel {

    id?: number | undefined;
    nome?: string | undefined;
    tipo?: string | undefined;
    itens?: string[] | undefined;
    itens_filter?: string[] | undefined;
    valor_principal?: string | undefined;
    valor_secundario?: string | undefined;
    texto_associado?: string | undefined;
    opcional?: boolean | undefined;
    cond_item?: string | undefined;
    valores_com_inconsistencia?: any[] | undefined;

    // CAMPO DE CONTROLE (NAO USADO NO BACK)
    _itensAux?: string;
    _condAux?: string[] | undefined;

    constructor(id?: number,
                nome?: string,
                tipo?: string,
                itens?: string[],
                _itensAux?: string,
                valorPrincipal?: string,
                valorSecundario?: string,
                texto_associado?: string,
                opcional?: boolean,
                cond_item?: string,
                valores_com_inconsistencia?: any[]) {
        this.id = id;
        this.nome = nome;
        this.tipo = tipo;
        this.itens = itens;
        this._itensAux = _itensAux;
        this.valor_principal = valorPrincipal;
        this.texto_associado = texto_associado;
        this.valor_secundario = valorSecundario;
        this.opcional = opcional;
        this.cond_item = cond_item;
        this.valores_com_inconsistencia = valores_com_inconsistencia;
    }
}
